import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { Outlet } from 'react-router-dom';

export default function AdminUsersLayout() {
  return (
    <>
      <CC.Box
        bg={CC.useColorModeValue('white', 'gray.800')}
        py={{ base: 4, md: 10 }}
        px={{ base: 4, md: 8 }}
      >
        <Outlet />
      </CC.Box>
    </>
  );
}
